export default "__VITE_ASSET__C_eSXJ6L__"